import { useEffect, useState } from "react";
import { Download, Eye } from "lucide-react";
import { api, API_BASE } from "../../lib/api";

// Carte vendeur « Listes de prix coûtant » — demande du propriétaire (2026-10-20) :
// la case « Voir les prix coûtants » cochée par l'admin sur une liste précise la
// rend visible ICI, dans le portail vendeur (onglet Paramètres). LECTURE SEULE :
// consulter en ligne ou télécharger — jamais de modification ni d'archivage.
// La carte ne s'affiche que si au moins une liste est partagée avec le vendeur.

const TAILLE = (o) => (o >= 1048576 ? `${(o / 1048576).toFixed(1)} Mo` : `${Math.max(1, Math.round(o / 1024))} Ko`);
const DATE = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-CA", { year: "numeric", month: "short", day: "numeric" }) : "");

export default function VendeurPrixCoutantCard() {
  const [listes, setListes] = useState(null); // null = chargement

  useEffect(() => {
    api.get("/vendeur/prix-coutant")
      .then((r) => setListes(r.data.items || []))
      .catch(() => setListes([]));
  }, []);

  if (!listes || listes.length === 0) return null; // rien de partagé → carte invisible

  return (
    <div className="bg-surface border border-gold/25 rounded-xl p-7 mt-8 space-y-3" data-testid="vendeur-prix-coutant-card">
      <div>
        <p className="font-semibold text-gold">Listes de prix coûtant</p>
        <p className="text-xs text-ivory/70 mt-1">
          Listes partagées avec vous par le propriétaire — consultation en ligne ou
          téléchargement, en lecture seule.
        </p>
      </div>
      <div className="space-y-2">
        {listes.map((l) => (
          <div key={l.id} className="flex items-center justify-between gap-3 flex-wrap border border-ivory/10 rounded-lg px-4 py-3"
            data-testid={`vendeur-prix-coutant-item-${l.id}`}>
            <div className="min-w-0">
              <p className="text-sm font-medium truncate" data-testid={`vendeur-prix-coutant-titre-${l.id}`}>{l.title}</p>
              <p className="text-xs text-ivory/55 truncate">{l.filename} · {TAILLE(l.size)} · {DATE(l.updated_at)}</p>
            </div>
            <div className="grid grid-cols-2 gap-2 w-full sm:w-auto sm:flex sm:flex-wrap sm:justify-end shrink-0">
              <a href={`${API_BASE}/api/vendeur/prix-coutant/${l.id}/fichier`} target="_blank" rel="noopener noreferrer"
                data-testid={`vendeur-prix-coutant-voir-${l.id}`}
                className="inline-flex items-center justify-center gap-1.5 border border-emerald-500/50 text-emerald-300 text-xs px-3.5 py-1.5 rounded-full hover:bg-emerald-500 hover:text-ink transition-colors">
                <Eye className="w-3.5 h-3.5" /> Voir en ligne
              </a>
              <a href={`${API_BASE}/api/vendeur/prix-coutant/${l.id}/fichier?dl=1`}
                data-testid={`vendeur-prix-coutant-telecharger-${l.id}`}
                className="inline-flex items-center justify-center gap-1.5 border border-ivory/25 text-ivory/70 text-xs px-3.5 py-1.5 rounded-full hover:border-gold hover:text-gold transition-colors">
                <Download className="w-3.5 h-3.5" /> Télécharger
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
